export default __webpack_public_path__ + "static/nails_men-6082e1368d47d9713cd6b37b619487d0.jpg";